import { technologies } from "./technologies.js"

const projects = {
  projects: [
    {
      name: "PayOrPray",
      icon: "projects/payorpray.png",
      description: "PayOrPray is a expense-splitting web app created in 24 hours for a hackathon. Fully-featured expense splitting with a gambling minigame on top!",
      tech: ["React", "JavaScript", "PWA"],
      links: {blog: "https://harjun751.github.io/blog/2026/01/18/hack-n-roll-2026.html", gh: "https://github.com/Harjun751/PayOrPray", web: "https://payorpray-frontend.onrender.com/"}
    },
    {
      name: "BuffBoys",
      icon: "projects/buffboys.png",
      description: "A mod for a game called Monster Hunter. Required mining data and writing a script in C# - read the blog for more info!",
      tech: ["C#"],
      links: {gh: "https://github.com/Harjun751/mhwilds-difficulty-script", blog: "https://harjun751.github.io/blog/2025/04/11/im-a-modder-now.html", web: "https://www.nexusmods.com/monsterhunterwilds/mods/1201?tab=description"}
    },
    {
      name: "Skyhelix Helper",
      icon: "projects/skyhelix-helper.png",
      description: "An app I created for my part-time workplace to simplify queue management.",
      tech: ["PWA","VueJS", "Docker"],
      links: {gh:"https://github.com/Harjun751/skyhelix-helper", blog:"https://harjun751.github.io/blog/2024/05/06/Optimizing-my-job-with-algorithms.html"}
    },
    {
      name: "NewsPaper",
      icon: "projects/newspaper.png",
      description: "NewsPaper is a RSS reader with web scraping for full text extraction. I built it because I was annoyed with another RSS reader I downloaded from the play store.",
      tech: ["PWA","Rust","VueJS", "Docker","CI/CD"],
      links: {gh:"https://github.com/Harjun751/rss-reader", blog:"https://harjun751.github.io/blog/2024/03/16/my-RSS-reader.html"}
    },
    {
      name: "Blogsite",
      icon: "projects/blog.png",
      description: "My blog site! I write informally about my projects and tech stuff.",
      tech: ["HTML"],
      links: {gh:"https://github.com/Harjun751/blog", web:"https://harjun751.github.io/blog/", blog:"https://harjun751.github.io/blog/2023/12/05/creating-a-blog.html"}
    },
    {
      name: "Monopoly",
      icon: "projects/monopoly.webp",
      description: "A Monopoly simulation built on Java. The backend utilizes the Spring framework. The project was made to deepen understanding of Java, and to prove a point.",
      tech: ["VueJS","Java"],
      links: {gh:"https://github.com/Harjun751/JavaMonopoly", blog:"https://harjun751.github.io/blog/2023/12/05/creating-a-blog.html"}
    },
    {
      name: "Ooper",
      icon: "projects/ooper.gif",
      description: "Ooper is a ride sharing platform created for an assignment. It utilizes a microservice architecture coded in Go for the backend of the application, and uses VueJS as the frontend framework. ",
      tech: ["VueJS","Golang","Microservices","SQL"],
      links: {gh:"https://github.com/Harjun751/ETI-Ooper"}
    },
    {
      name: "Portfolio",
      icon: "projects/portfolio.gif",
      description: "This website. Created for fun!",
      tech: ["VueJS"],
      links: {gh:"https://github.com/Harjun751/portfolio"}
    },
    {
      name: "Edufi-Timetable",
      icon: "projects/edufi-timetable.gif",
      description: "EduFi-Timetable is a microservice part of the 'EduFi' application created for the Emerging Trends in IT module assignment 2. It uses ExpressJS as the backend, with the template engine 'LiquidJS'. The frontend is a simple html page along with tailwindcss for styling. The application is Dockerized, and there is a simple lint workflow for the project.",
      tech: ["Docker","CI/CD","SQL"],
      links: {gh:"https://github.com/Harjun751/ETI-EduFi-Timetable"}
    },
    {
      name: "Simpcity",
      icon: "projects/simpcity.png",
      description: "Simpcity is a simple console application game. The project demonstrates collaborative work done on github.",
      tech: ["Python","CI/CD"],
      links: {gh:"https://github.com/notyumin/SimpCity"}
    },
  ],
  open:false,
  description:'',
  icon:'projects/ooper.gif',
  name: "",
  tech: [],
  links: {},
  technologies: technologies,
};
export { projects };
